import { render, staticRenderFns } from "./MachineParamViewTable.vue?vue&type=template&id=504e0dab&scoped=true"
import script from "./MachineParamViewTable.vue?vue&type=script&lang=js"
export * from "./MachineParamViewTable.vue?vue&type=script&lang=js"
import style0 from "./MachineParamViewTable.vue?vue&type=style&index=0&id=504e0dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e0dab",
  null
  
)

export default component.exports